exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__inputNumber___7YPwT{position:relative}.styles__inputNumber___7YPwT input::placeholder{color:#8c9ba5}.styles__prependLabel___3kRnm{bottom:.8rem;color:#5a6872;font-size:.875rem;left:8px;position:absolute}.styles__prependLabel___3kRnm+input[type=text]{padding-left:3rem !important}", ""]);

// Exports
exports.locals = {
	"inputNumber": "styles__inputNumber___7YPwT",
	"prependLabel": "styles__prependLabel___3kRnm"
};